import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const DangerZone = ({ onUnsubscribe, unsubscribeLoading }) => {
  const [showModal, setShowModal] = useState(false);
  const [confirmText, setConfirmText] = useState('');

  const handleConfirm = () => {
    if (confirmText?.trim()?.toLowerCase() === 'avslutt') {
      onUnsubscribe?.();
      setShowModal(false);
      setConfirmText('');
    }
  };

  const handleClose = () => {
    setShowModal(false);
    setConfirmText('');
  };

  return (
    <>
      <div style={{
        background: 'rgba(180,20,20,0.06)',
        border: '1px solid rgba(180,20,20,0.25)',
        padding: '40px',
        position: 'relative',
        overflow: 'hidden',
        marginBottom: '32px'
      }}>
        {/* Color block accent */}
        <div style={{
          position: 'absolute', top: 0, left: 0,
          width: '4px', height: '100%',
          background: 'linear-gradient(to bottom, #B41414, rgba(180,20,20,0.3))'
        }} />

        {/* Background texture number */}
        <div style={{
          position: 'absolute', right: '-10px', top: '-20px',
          fontFamily: 'Impact, Arial Black, sans-serif',
          fontSize: '120px', fontWeight: 900,
          color: 'rgba(180,20,20,0.06)',
          lineHeight: 1, userSelect: 'none', pointerEvents: 'none'
        }}>⚠</div>

        <div style={{ paddingLeft: '20px', position: 'relative', zIndex: 1 }}>
          <div style={{
            fontFamily: 'Syne, sans-serif',
            fontSize: '0.65rem', fontWeight: 700,
            color: '#B41414', letterSpacing: '0.2em',
            textTransform: 'uppercase', marginBottom: '12px',
            display: 'flex', alignItems: 'center', gap: '8px'
          }}>
            <Icon name="AlertTriangle" size={12} color="#B41414" />
            FARESONE — AVSLUTT ABONNEMENT
          </div>

          <div style={{
            fontFamily: 'Impact, Arial Black, sans-serif',
            fontSize: 'clamp(22px, 3vw, 32px)',
            fontWeight: 900, color: '#EEF0F2',
            letterSpacing: '-0.02em', textTransform: 'uppercase',
            marginBottom: '8px'
          }}>AVSLUTT ABONNEMENT</div>

          <p style={{
            fontFamily: 'Georgia, serif', fontStyle: 'italic',
            fontSize: '0.9375rem', color: 'rgba(138,149,163,0.7)',
            lineHeight: 1.6, marginBottom: '28px', maxWidth: '520px'
          }}>
            Hvis du avslutter abonnementet vil du ikke lenger motta nyhetsbrev fra NordPass. 
            Denne handlingen kan ikke angres automatisk — du må melde deg på igjen manuelt.
          </p>

          <button
            onClick={() => setShowModal(true)}
            style={{
              padding: '13px 28px',
              background: 'transparent',
              border: '2px solid #B41414',
              color: '#B41414',
              fontFamily: 'Syne, sans-serif',
              fontSize: '0.8125rem',
              fontWeight: 700,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              cursor: 'pointer',
              display: 'flex', alignItems: 'center', gap: '8px',
              transition: 'all 200ms ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(180,20,20,0.12)';
              e.currentTarget.style.borderColor = '#CC2020';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.borderColor = '#B41414';
            }}
          >
            <Icon name="UserX" size={14} color="#B41414" />
            Avslutt abonnement
          </button>
        </div>
      </div>
      {/* Confirmation Modal */}
      {showModal && (
        <div style={{
          position: 'fixed', inset: 0, zIndex: 1000,
          background: 'rgba(5,10,18,0.92)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: '20px'
        }}
          onClick={(e) => { if (e?.target === e?.currentTarget) handleClose(); }}
        >
          <div style={{
            background: '#0A1220',
            border: '1px solid rgba(180,20,20,0.4)',
            padding: '48px',
            maxWidth: '480px',
            width: '100%',
            position: 'relative',
            overflow: 'hidden'
          }}>
            {/* Modal diagonal accent */}
            <div style={{
              position: 'absolute', top: 0, left: 0,
              width: '4px', height: '100%',
              background: '#B41414'
            }} />

            {/* Close button */}
            <button
              onClick={handleClose}
              style={{
                position: 'absolute', top: '16px', right: '16px',
                background: 'transparent', border: 'none',
                cursor: 'pointer', padding: '4px',
                display: 'flex', alignItems: 'center', justifyContent: 'center'
              }}
            >
              <Icon name="X" size={18} color="rgba(138,149,163,0.6)" />
            </button>

            <div style={{ paddingLeft: '16px' }}>
              {/* Warning icon */}
              <div style={{
                width: '56px', height: '56px',
                border: '2px solid #B41414',
                background: 'rgba(180,20,20,0.1)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                marginBottom: '24px',
                transform: 'rotate(-2deg)'
              }}>
                <Icon name="AlertTriangle" size={24} color="#B41414" />
              </div>

              <div style={{
                fontFamily: 'Impact, Arial Black, sans-serif',
                fontSize: '1.75rem', fontWeight: 900,
                color: '#EEF0F2', letterSpacing: '-0.02em',
                textTransform: 'uppercase', marginBottom: '12px'
              }}>ER DU SIKKER?</div>

              <p style={{
                fontFamily: 'Georgia, serif', fontStyle: 'italic',
                fontSize: '0.9375rem', color: 'rgba(138,149,163,0.75)',
                lineHeight: 1.65, marginBottom: '28px'
              }}>
                Du er i ferd med å avslutte abonnementet ditt. Skriv <strong style={{ color: '#B41414', fontStyle: 'normal' }}>AVSLUTT</strong> i feltet nedenfor for å bekrefte.
              </p>

              <input
                type="text"
                value={confirmText}
                onChange={(e) => setConfirmText(e?.target?.value)}
                placeholder="Skriv AVSLUTT for å bekrefte"
                style={{
                  width: '100%',
                  padding: '13px 16px',
                  background: 'rgba(255,255,255,0.04)',
                  border: '1px solid rgba(180,20,20,0.3)',
                  color: '#EEF0F2',
                  fontFamily: 'JetBrains Mono, monospace',
                  fontSize: '0.875rem',
                  outline: 'none',
                  marginBottom: '20px',
                  boxSizing: 'border-box',
                  letterSpacing: '0.05em'
                }}
                onFocus={(e) => { e.target.style.borderColor = 'rgba(180,20,20,0.6)'; }}
                onBlur={(e) => { e.target.style.borderColor = 'rgba(180,20,20,0.3)'; }}
              />

              <div style={{ display: 'flex', gap: '12px' }}>
                <button
                  onClick={handleClose}
                  style={{
                    flex: 1, padding: '13px',
                    background: 'transparent',
                    border: '1px solid rgba(255,255,255,0.12)',
                    color: 'rgba(138,149,163,0.8)',
                    fontFamily: 'Syne, sans-serif',
                    fontSize: '0.8125rem', fontWeight: 700,
                    letterSpacing: '0.06em', textTransform: 'uppercase',
                    cursor: 'pointer', transition: 'all 200ms ease'
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.25)'; e.currentTarget.style.color = '#EEF0F2'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.12)'; e.currentTarget.style.color = 'rgba(138,149,163,0.8)'; }}
                >
                  Avbryt
                </button>
                <button
                  onClick={handleConfirm}
                  disabled={confirmText?.trim()?.toLowerCase() !== 'avslutt' || unsubscribeLoading}
                  style={{
                    flex: 1, padding: '13px',
                    background: confirmText?.trim()?.toLowerCase() === 'avslutt' ? '#B41414' : 'rgba(180,20,20,0.3)',
                    border: 'none',
                    color: '#EEF0F2',
                    fontFamily: 'Syne, sans-serif',
                    fontSize: '0.8125rem', fontWeight: 700,
                    letterSpacing: '0.06em', textTransform: 'uppercase',
                    cursor: confirmText?.trim()?.toLowerCase() === 'avslutt' ? 'pointer' : 'not-allowed',
                    transition: 'background 200ms ease',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px'
                  }}
                >
                  {unsubscribeLoading ? (
                    <><Icon name="Loader" size={13} color="#EEF0F2" /> Behandler...</>
                  ) : (
                    <><Icon name="UserX" size={13} color="#EEF0F2" /> Bekreft avslutt</>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DangerZone;
